import Form from './FormComponent';
import List from './ListComponent';

export default {
  Form,
  List,
};



// WEBPACK FOOTER //
// ./src/components/aws/accounts/teamSharing/index.js